import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getPrices, createPrice, updatePrice, deletePrice } from "../lib/api";
import { formatRp } from "../lib/constants";

const empty = { name: "", type: "jasa", price: "" };

export const PriceManager = ({ open, onClose, onChanged }) => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = async () => setList(await getPrices());
  useEffect(() => { if (open) { load(); setForm(empty); setEditId(null); } }, [open]);
  if (!open) return null;

  const save = async (e) => {
    e.preventDefault();
    if (!form.name || form.price === "") return toast.error("Nama dan harga wajib diisi");
    const payload = { name: form.name, type: form.type, price: Number(form.price) || 0 };
    try {
      if (editId) await updatePrice(editId, payload);
      else await createPrice(payload);
      toast.success("Harga tersimpan");
      setForm(empty); setEditId(null);
      await load(); onChanged && onChanged();
    } catch { toast.error("Gagal menyimpan"); }
  };

  const onDelete = async (p) => {
    if (!window.confirm(`Hapus "${p.name}" dari daftar harga?`)) return;
    await deletePrice(p.id); toast.success("Dihapus");
    await load(); onChanged && onChanged();
  };

  const inputCls = "w-full px-3 py-2 border border-slate-300 rounded-lg text-xs focus:ring-2 focus:ring-teal-500 outline-none";

  return (
    <div className="no-print fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl my-auto flex flex-col max-h-[92vh] animate-fade-up" data-testid="prices-modal">
        <div className="px-6 py-4 bg-gradient-to-r from-slate-900 to-teal-800 text-white flex justify-between items-center">
          <h3 className="text-base sm:text-lg font-bold flex items-center gap-2"><i className="ph-bold ph-tag text-teal-300" /> Daftar Harga (Jasa & Bahan)</h3>
          <button onClick={onClose} className="text-slate-300 hover:text-white p-1 rounded-lg hover:bg-white/10"><i className="ph-bold ph-x text-xl" /></button>
        </div>
        <div className="p-6 overflow-y-auto space-y-5">
          <form onSubmit={save} className="bg-slate-50 p-4 rounded-xl border border-slate-200 grid grid-cols-12 gap-2 items-end">
            <div className="col-span-5">
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Nama Jasa / Bahan *</label>
              <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} placeholder="mis. Cuci AC 1 PK" data-testid="price-name" />
            </div>
            <div className="col-span-3">
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Jenis</label>
              <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className={`${inputCls} bg-white`} data-testid="price-type">
                <option value="jasa">Jasa</option>
                <option value="bahan">Bahan</option>
              </select>
            </div>
            <div className="col-span-3">
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Harga (Rp)</label>
              <input type="number" value={form.price} onChange={(e) => setForm({ ...form, price: e.target.value })} className={inputCls} placeholder="0" data-testid="price-value" />
            </div>
            <div className="col-span-1">
              <button type="submit" className="w-full py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg" data-testid="price-save-btn"><i className="ph-bold ph-check" /></button>
            </div>
            {editId && <div className="col-span-12"><button type="button" onClick={() => { setForm(empty); setEditId(null); }} className="text-xs font-bold text-slate-500">Batal edit</button></div>}
          </form>

          <div className="space-y-2">
            {list.length === 0 && <p className="text-center text-xs text-slate-400 py-4">Belum ada daftar harga.</p>}
            {list.map((p) => (
              <div key={p.id} className="flex items-center justify-between gap-3 p-3 border border-slate-200 rounded-xl" data-testid={`price-row-${p.id}`}>
                <div className="min-w-0 flex items-center gap-2">
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${p.type === "jasa" ? "bg-teal-100 text-teal-700" : "bg-amber-100 text-amber-700"}`}>{p.type === "jasa" ? "JASA" : "BAHAN"}</span>
                  <span className="font-bold text-slate-800 text-sm truncate">{p.name}</span>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <span className="font-mono font-bold text-slate-700 text-sm">{formatRp(p.price)}</span>
                  <button onClick={() => { setForm({ name: p.name, type: p.type, price: p.price }); setEditId(p.id); }} className="text-slate-500 hover:text-slate-700"><i className="ph-bold ph-pencil-simple" /></button>
                  <button onClick={() => onDelete(p)} className="text-rose-500 hover:text-rose-700"><i className="ph-bold ph-trash" /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
